import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default stripePromise;

// Pricing configuration
export const PRICE_PER_USER = 5; // £5 per user per month (standalone)
export const BUNDLE_PRICE_PER_USER = 2.5; // £2.50 per user per month (if also subscribed to BuildMyShifts)
export const CURRENCY = 'gbp';

// Test card numbers for development
export const TEST_CARDS = {
  success: '4242 4242 4242 4242',
  declined: '4000 0000 0000 0002',
  requiresAuth: '4000 0025 0000 3155'
};